import { Layer, LayerProps } from 'shared/map-exports';
import { useMapLayerEvents } from '../useMapLayerEvents';
import {
  ExternalFeatureLayerProps,
  ExternalFeatureProperties,
  ExternalLayerStylesInput,
} from './ExternalFeatureLayer.types';
import { useLayerClickHandler } from './useLayerClickHandler';

type PointLayerProps = ExternalFeatureLayerProps;

const getPointLayerStyles = (input: ExternalLayerStylesInput): LayerProps => {
  if (input.displayStyleType !== 'simple_single_color') {
    throw new Error(
      'Point layer styles require simple_single_color display style',
    );
  }
  const { sourceId, sourceLayer, color } = input;
  return {
    type: 'symbol',
    source: sourceId,
    'source-layer': sourceLayer,
    layout: {
      'icon-image': 'CustomLayerLocationPin',
      'icon-allow-overlap': true,
      'icon-anchor': 'bottom',
      'icon-ignore-placement': true,
    },
    paint: {
      'icon-color': color,
    },
  };
};

export const PointLayer = (props: PointLayerProps): JSX.Element => {
  const {
    sourceId,
    featureLayer: { shortName, displayStyleData, displayName, geomType },
  } = props;
  const clickHandler = useLayerClickHandler(sourceId, displayName, geomType);

  useMapLayerEvents<ExternalFeatureProperties>({
    layerId: `${sourceId}_point`,
    onClick: clickHandler,
  });

  return (
    <Layer
      id={`${sourceId}_point`}
      {...getPointLayerStyles({
        sourceId,
        sourceLayer: shortName,
        ...displayStyleData,
      })}
    />
  );
};
